import { doGet, doPut, doPost, doDelete } from './common';

const download = (id) => {
  return doGet(`/api/order/${id}/download`, null, 'blob').then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const getList = (pagination = undefined, sort = undefined) => {
  let filter = '';
  if (pagination) {
    filter = `?limit=${pagination.limit}&offset=${pagination.offset}`;
  }
  if (sort) {
    if (filter === '') filter += `&sort=${sort}`;
    else filter = `?sort=${sort}`;
  }

  return doGet(`/api/order/contract${filter}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getListCount = (id) => {
  return doGet(`/api/order/contract/count`).then(res => (res.data.count))
    .catch(err => { })
    .finally(() => {

    });
}

const getListEnabled = () => {
  return doGet(`/api/order`).then(res => (res.data.filter(x => x.enabled === true)))
    .catch(err => { })
    .finally(() => {

    });
}

const getById = (id) => {
  return doGet(`/api/order/${id}`)
    .catch(err => { })
    .finally(() => {

    });
}

const insert = (id, params) => {
  return doPost(`/api/order/${id}/contract`, params).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}

const insertGoods = (id, params) => {
  return doPost(`/api/order/${id}/contract/goods`, params).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}

const getListContractGoods = (id) => {
  return doGet(`/api/order/${id}/contract/goods`).then(res => (res.data))
  .catch(err => { })
  .finally(() => {

  });
}
const updateById = (id, params) => {
  return doPut(`/api/order/${id}/contract`, params).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}
const deleteById = (order_id, supplier_ids) => {
  return doDelete(`/api/order/${order_id}/contract/${supplier_ids}`).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}
export {
  download,
  getList,
  getListCount,
  getListEnabled,
  getById,
  updateById,
  insert,
  insertGoods,
  getListContractGoods,
  deleteById,
}